import axios from "axios";
import { getLocalStorage, removeLocalStorage } from "./browserStorage";
import { apiUrl } from "./common";

const apiInstance = axios.create({
  baseURL: apiUrl,
});

apiInstance.interceptors.request.use(
  (config) => {
    const accessToken = getLocalStorage("accessToken");

    if (accessToken) {
      config.headers.Authorization = `Bearer ${accessToken}`;
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

apiInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    console.log("error from api", error);
    const { pathname, origin } = window.location;

    const { logout, message, notAllowedToOrganization } =
      error?.response?.data || {};

    if (notAllowedToOrganization) {
      removeLocalStorage("organizationId");
      removeLocalStorage("pageId");
      window.location.href = origin + "/organization";
    }

    const clearAndLogout = message === "jwt expired" || logout;

    const parsedData = pathname.split("/");

    if (pathname !== "/login" && clearAndLogout) {
      localStorage.clear();
      window.location.href = origin + "/" + parsedData[1] + "/login";
    }

    return Promise.reject(error);
  }
);

export default apiInstance;
